import { Outlet } from 'react-router';
import { Header } from '@/components/layout/Header';
import { Sidebar } from '@/components/layout/Sidebar';
import { ErrorNotice } from '@/components/portal/PortalPage';
import { useProfile } from '@/features/portal/usePortal';
import './PortalLayout.css';

export const PortalLayout = () => {
  const profile = useProfile();
  return (
    <div className="platform-layout platform-layout--page">
      <Header />
      <Sidebar />
      <main className="platform-content">
        {profile.isError ? (
          <ErrorNotice
            onRetry={() => {
              void profile.refetch();
            }}
          >
            {profile.error.message}
          </ErrorNotice>
        ) : (
          <Outlet />
        )}
      </main>
    </div>
  );
};
